// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatWorkflowBundle" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatWorkflowSkillRefGenShape } from "./chat-workflow-skill-ref.gen";
import { ChatWorkflowScoringConfigGenShape } from "./chat-workflow-scoring-config.gen";

export const ChatWorkflowBundleGenShape = z.strictObject({
  skillRefs: z.array(ChatWorkflowSkillRefGenShape),
  scoring: ChatWorkflowScoringConfigGenShape,
  metadataSchemaVersion: z.number(),
  taggingSkillRef: ChatWorkflowSkillRefGenShape.optional(),
});
